import { render, staticRenderFns } from "./DynamicAmount.vue?vue&type=template&id=238cd89b&"
import script from "./DynamicAmount.vue?vue&type=script&lang=js&"
export * from "./DynamicAmount.vue?vue&type=script&lang=js&"
import style0 from "./DynamicAmount.vue?vue&type=style&index=0&id=238cd89b&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports